<template>
  <div class="absolute h-full w-[2px] left-[-38px]" :class="!isLast ? 'border-l border-dashed border-gray' : ''">

    <div class="ml-[-20px] w-[40px] h-[40px] flex items-center justify-center border rounded-[50%]" :class="{
    'border-gray-30 border-solid bg-white': status === 'parked',
    'border-yellow border-solid bg-primary-10': status === 'ongoing',
    'border-turquoise-30 border-solid bg-turquoise-10': status === 'new',
    'border-green-light border-solid bg-green-10': status === 'finished'
    }">
      <svg v-if="status == 'parked'" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M4 9.5C4.55 9.5 5 9.05 5 8.5V3.5C5 2.95 4.55 2.5 4 2.5C3.45 2.5 3 2.95 3 3.5V8.5C3 9.05 3.45 9.5 4 9.5ZM7 3.5V8.5C7 9.05 7.45 9.5 8 9.5C8.55 9.5 9 9.05 9 8.5V3.5C9 2.95 8.55 2.5 8 2.5C7.45 2.5 7 2.95 7 3.5Z" fill="black"/>
      </svg>
      <svg v-else-if="status == 'new'" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.25 8.23828L12.6501 11.9555C11.6723 12.5624 10.3279 12.5624 9.35009 11.9555L2.75 8.23828V14.8078C2.75 15.7425 3.57081 16.5001 4.58333 16.5001H17.4167C18.4292 16.5001 19.25 15.7425 19.25 14.8078V8.23828Z" fill="#007893"/>
        <path d="M19.25 6.96715L12.6501 10.5605C11.6723 11.1472 10.3279 11.1472 9.35009 10.5605L2.75 6.96715C2.75 6.23382 3.66667 5.50049 4.58333 5.50049H17.4167C18.5096 5.50049 19.25 6.23382 19.25 6.96715Z" fill="#007893"/>
      </svg>
      <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="8" :fill="status === 'finished' ? '#96C11F' : '#FFD000'"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2545 4.69505C12.561 4.97368 12.5836 5.44802 12.305 5.75451L6.80297 11.8067L3.74828 9.05748C3.4404 8.78038 3.41544 8.30616 3.69254 7.99828C3.96963 7.6904 4.44385 7.66544 4.75173 7.94253L6.69704 9.69331L11.1951 4.7455C11.4737 4.43901 11.948 4.41642 12.2545 4.69505Z" fill="black"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Status',
  data() {

  },
  props: {
    status: {
      required: true
    },
    isLast: {
      required: true
    },
  },
  mounted() {},
};
</script>
